import gql from "graphql-tag"

const fragment = gql`
  fragment mediaRental on MediaRental {
    uuid
    userId
    mediaId
    expiresAt
    mediaType
    paymentOrderId
    paymentOrder {
      uuid
      amount
      currency
      status
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
